import { getConfig } from "@/services/authorization";
import { getTokenToLocalStorage } from "@/utils/token";
import { makeAutoObservable, action, toJS, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";
import agentUser from '@/stores/agentUser';
interface Itabs {
  key: any;
  title: string;
  path: string;
  icon?: string;
  src?: string;
  platform?: string;
  isFinite?: boolean;
  content?: string;
  data?: any;
}
class Store {
  tabs: Itabs[] = [
    {
      key: 0,
      title: "工作台",
      path: "/matrix",
      icon: "",
    },
  ];
  logList = [];
  isClient = false;
  isLive = false;
  tabsActiveKey = 0;
  isShowDoc = false;
  configUrl = "";
  webviewKey = "";
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "clientTabs",
      properties: ["isClient"],
      storage: window.localStorage,
    });
  }
  @action addTab = (tab) => {
    const token = localStorage.getItem("Token");
    const auth = () => {
      const isPathDuplicate = this.tabs.find(
        (t) =>
          (t.key == tab.key || t.path == tab.path) && t.title !== "账号授权"
      );
      if (
        isPathDuplicate &&
        Object.keys(isPathDuplicate).length &&
        tab.isFinite !== false
      ) {
        this.setActivePath(isPathDuplicate.key);
        this.webviewKey = isPathDuplicate.key;
        return;
      }
      const maxKey = tab.key
        ? tab.key
        : (this.tabs.length > 0
            ? Math.max(
                ...this.tabs
                  .filter((t) => typeof t.key === "number")
                  .map((v) => v.key)
              )
            : 0) + 1;

      if (typeof tab.key !== "number") {
        this.webviewKey = maxKey;
      }
      const newTab = { ...tab, key: maxKey };
      this.setActivePath(maxKey);
      this.tabs.push(newTab);
      setTimeout(() => {
        // const container = document.getElementById(`${tab.key}`);
        // 获取当前激活的 tab 信息

        const activeTab = this.tabs.find((v) => v.key === this.tabsActiveKey);

        // 创建新的 webview 元素
        const webview = document.createElement("webview") as any;
        webview.src = activeTab?.src;
        webview.setAttribute("id", `webview-${activeTab?.key}`);
        webview.setAttribute("style", `width:100%;height:100%;`);
        webview.setAttribute("nodeintegration", "false"); // 禁用 Node 集成
        webview.setAttribute("disablewebsecurity", "true"); // 禁用 Web 安全
        webview.setAttribute("allowpopups", "true"); // 允许弹出窗口
        webview.setAttribute("partition", `persist:vidpost_${activeTab?.key}`); // 设置 partition
        // webview.setAttribute("useragent", navigator.userAgent);
        // webview.setAttribute(
        //   "useragent",
        //   "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/131.0.0.0 Safari/537.36",
        // );
        webview.setAttribute(
          "useragent",
          "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/135.0.0.0 Safari/537.36 Edg/135.0.0.0"
        );
        // 监听 did-attach 事件，确保 WebView 已附加到 DOM
        webview.addEventListener("did-attach", () => {
          // 使用 setTimeout 延迟执行，确保 WebView 完全初始化
          setTimeout(() => {
            try {
              const webviewId = webview.getWebContentsId();
              // 调用 IPC 来处理网络监控等逻辑
              window.electron?.ipcRenderer.send(
                "webview-network-monitor",
                webviewId,
                activeTab.platform,
                activeTab?.key,
                tab?.data,
                agentUser.isThisAgent ? agentUser.activeTeamId : undefined
              );
            } catch (error) {
              console.error("Error getting WebView contents ID:", error);
            }
          }, 100); // 延迟100毫秒，确保 WebView 完全准备好
        });
        // 将新的 webview 元素添加到容器中
        document.getElementById(activeTab?.key).appendChild(webview);
        // webview.addEventListener("dom-ready", () => {
        //   // webview.openDevTools();
        // });
      });
    };
    if (window.electron.ipcRenderer.authDouyin) {
      if (tab.platform != 1) {
        auth();
      } else {
        window.electron?.ipcRenderer.authDouyin({
          key: tab.key,
          auth_data: tab?.data,
          webToken: token,
          teamId:  agentUser.isThisAgent ? agentUser.activeTeamId : undefined
        });
      }
    } else {
      auth();
    }
  };
  @action updateTab = (tab) => {
    // const index = this.tabs.findIndex((v) => v.key === tab.key);
    this.tabs[0] = tab;
    this.setActivePath(tab.key);
  };
  @action setIsShowDoc = async (status) => {
    if (status) {
      // const config = await getConfig();
      this.configUrl =
        "https://cct3npbwsp.feishu.cn/docx/YU7UdzYL5o0rzlxh1IWcACVdn3e?from=from_copylink";
    }
    this.isShowDoc = status;
  };
  @action removeTab = (key) => {
    // 如果要删除的路径等于当前选中的路径
    if (this.tabsActiveKey == key) {
      const preIndex = this.tabs.findIndex((v) => v.key == key) - 1;
      if (preIndex < 0) return;
      this.setActivePath(this.tabs[preIndex].key);
    }
    this.tabs = this.tabs.filter(
      (tab) => tab.key !== this.tabs.find((v) => v.key == key).key
    );
  };
  @action setActivePath = (key) => {
    this.tabsActiveKey = key;
  };
  @action updateIsClient = (val) => {
    this.isClient = val;
  };
  @action setIsLive = (val) => {
    this.isLive = val;
  };
  addLog(data: any) {
    if (this.logList.length > 10000) {
      this.logList.shift();
    }
    this.logList.push(data);
  }
}

const ClientTabs = new Store();
export default ClientTabs;
